// src/components/ThankYou.js
import React from 'react';

const ThankYou = () => (
  <div className="thank-you-container">
    <h2>Thank you for submitting the form!</h2>
    <p>We have received your response and will be in touch soon.</p>
  </div>
);

export default ThankYou;
